import { log } from "console";
/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-27 10:29:40
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: string = "login";

export const registerType = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setRegisterType: (state, action: PayloadAction<string>) => {
      state = action.payload;
      return state;
    },
  },
});

const { actions, reducer } = registerType;
export const { setRegisterType } = actions;
export default reducer;
